import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AdminDashboardComponent } from './pages/admin-dashboard/admin-dashboard.component';
import { LawyerDashboardComponent } from './pages/lawyer-dashboard/lawyer-dashboard.component';
import { DataEntryDashboardComponent } from './pages/data-entry-dashboard/data-entry-dashboard.component';
import { NewClientsListComponent } from './components/new-clients-list/new-clients-list.component';
import { NewFilesListComponent } from './components/new-files-list/new-files-list.component';
import { NewPendingListComponent } from './components/new-pending-list/new-pending-list.component';
import { PendingFilesListComponent } from './components/pending-files-list/pending-files-list.component';
import { OverdueHearingsListComponent } from './components/overdue-hearings-list/overdue-hearings-list.component';
import { OverdueTimesheetsListComponent } from './components/overdue-timesheets-list/overdue-timesheets-list.component';
import { OverdueInvoicesListComponent } from './components/overdue-invoices-list/overdue-invoices-list.component';

@NgModule({
  declarations: [
    DashboardComponent,
    AdminDashboardComponent,
    LawyerDashboardComponent,
    DataEntryDashboardComponent,
    NewClientsListComponent,
    NewFilesListComponent,
    NewPendingListComponent,
    PendingFilesListComponent,
    OverdueHearingsListComponent,
    OverdueTimesheetsListComponent,
    OverdueInvoicesListComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    NgbModule,
    DashboardRoutingModule,
  ],
  exports: [
    NgbModule,
  ],
})
export class DashboardModule { }
